import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class FinancialItemWithLabelLinkQueryCriteriaClass extends BaseCriteriaModel {
  //for the header(s)
  keyword?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  descr?: Optional<string> = Optional.empty();
  exts?: Optional<Array<Exts>> = Optional.empty();
  links?: Optional<Array<LabelLink>> = Optional.empty();

}

export class Exts{
  param_code?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
}

export class LabelLink{
  guid_label_hdr?: Optional<string> = Optional.empty();
  header_table?: Optional<string> = Optional.empty();
}

export class FinancialItemWithLabelLinkCriteriaModelQuery {
  query = '';

  constructor(financialItemWithLabelLinkCriteriaModel: FinancialItemWithLabelLinkQueryCriteriaClass) {

    if (!financialItemWithLabelLinkCriteriaModel) {
      return;
    }

    this.query += financialItemWithLabelLinkCriteriaModel.keyword.filter(x => x !== '').map(x => '&keyword=' + x).orElse('');
    this.query += financialItemWithLabelLinkCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += financialItemWithLabelLinkCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += financialItemWithLabelLinkCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += financialItemWithLabelLinkCriteriaModel.descr.filter(x => x !== '').map(x => '&descr=' + x).orElse('');

    // TODO i think this is a POST request, so no need to have query params
    // this.query += financialItemWithLabelLinkCriteriaModel.exts.filter(x => x !== '').map(x => '&exts=' + x).orElse('');
    // this.query += financialItemWithLabelLinkCriteriaModel.links.filter(x => x !== '').map(x => '&links=' + x).orElse('');

    this.query += '&status=' + financialItemWithLabelLinkCriteriaModel.status;
    this.query += '&orderBy=' + financialItemWithLabelLinkCriteriaModel.orderBy;
    this.query += '&order=' + financialItemWithLabelLinkCriteriaModel.order;
    this.query += '&offset=' + financialItemWithLabelLinkCriteriaModel.offset + '&limit=' + financialItemWithLabelLinkCriteriaModel.limit;
  }
}
